<template>
  <el-table-column
    prop="valid_to"
    sortable="custom"
    label="Érvényesség vége"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      <div v-if="isExpired(scope.row)" class="expired">{{ scope.row.valid_to | date }}</div>
      <el-tag v-if="isExpired(scope.row)" size="mini" type="danger">Lejárt érvényesség</el-tag>
      <div v-if="!isExpired(scope.row)">{{ scope.row.valid_to | date }}</div>
    </template>
  </el-table-column>
</template>

<script>
import moment from 'moment';

export default {
  propName: 'valid_to',
  methods: {
    isExpired(row) {
      return moment().isAfter(moment(row.valid_to)) && (row.status !== 'done' || row.status !== 'failed');
    },
  },
};
</script>

<style scoped>
  .expired {
    color: #f56c6c;
    font-weight: 600;
  }
</style>
